import { render, staticRenderFns } from "./view_manage.vue?vue&type=template&id=1ebba941&scoped=true"
import script from "./view_manage.vue?vue&type=script&lang=js"
export * from "./view_manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebba941",
  null
  
)

export default component.exports